<template>
  <transition :name="transitionName">
    <div
      v-show="visible || fromPre"
      class="ah-mega-menu"
      :class="megaMenuClassPush"
      @click="handleClick"
    >
      <AhBar
        v-if="showTabBar"
        id="ah_bar_lang"
        :panel-title="title"
        class="ah-mega-menu__bar"
        @ah-bar-clicked="back"
      />

      <div class="ah-mega-menu__content">
        <div
          v-if="$slots.nav || listItems.length"
          class="ah-mega-menu__menu"
        >
          <slot
            v-if="$slots.nav"
            name="nav"
          />

          <div
            v-for="listItem in listItems"
            v-else-if="listItems && listItems.length"
            :key="listItem.id"
            class="ah-mega-menu__column"
            :class="'ah-mega-menu__column--' + setTitleClass(listItem)"
          >
            <span
              v-if="megaMenuColmunTitle(listItem)"
              role="heading"
              aria-level="2"
              class="ah-mega-menu-column__title"
            >
              {{ megaMenuColmunTitle(listItem) }}
            </span>
            <AhList
              marge="md"
            >
              <AhListItem
                v-for="(subListItem, index) in listItem.filter(
                  (cat) => !cat.type
                )"
                :key="index"
              >
                <AhMenuItem
                  :id="subListItem.id"
                  :variation="setTitleClass(listItem)"
                  :label="subListItem.text"
                  :class="subListItem.classes"
                  :url="subListItem.url"
                  :target="subListItem.url && subListItem.target"
                  @clicked="itemClicked(subListItem)"
                />
              </AhListItem>
            </AhList>
          </div>
        </div>

        <div
          v-if="$slots.pushs || listPushItems.length"
          :class="pushsClass()"
        >
          <slot
            v-if="$slots.pushs"
            name="pushs"
          />
          <component
            :is="iscomponentPushWidget"
            v-for="(item, index) in listPushItems"
            v-else
            :key="index"
            :class="PushWidgetClass"
            :card-content="item"
            @clickPush="widgetPushClicked"
            @clickWidget="widgetPushClicked"
          />
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import AhBar from '../../molecules/AhBar/AhBar.vue';
  import AhList from '../AhList/AhList.vue';
  import AhListItem from './../AhList/_internal/AhListItem.vue';
  import AhMenuItem from '../../molecules/AhMenuItem/AhMenuItem.vue';
  import AhCardWidget from '../../molecules/AhCardWidget/AhCardWidget.vue';
  import AhCardPush from '../../molecules/AhCardPush/AhCardPush.vue';

  export default {
    name: 'AhMegaMenu',
    components: {
      AhBar,
      AhList,
      AhListItem,
      AhMenuItem,
      AhCardWidget,
      AhCardPush,
    },
    inject: {
      fromPre: {
        from: 'prerendering',
        default: false
      }
    },
    props: {
      title: {
        type: String,
        default: '',
      },
      tracking: {
        type: String,
        default: '',
      },
      showTabBar: {
        type: Boolean,
        default: true,
      },
      visible: {
        type: Boolean,
        default: false,
      },
      transitionName: {
        type: String,
        default: 'ah-fade',
      },
      listItems: {
        type: Array,
        default: () => [],
      },
      listPushItems: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      isWidget() {
        return this.listPushItems[0] &&
          this.listPushItems[0].type === 'widget'
          ? true
          : false;
      },
      iscomponentPushWidget() {
        return this.isWidget ? 'AhCardWidget' : 'AhCardPush';
      },
      PushWidgetClass() {
        return this.isWidget
          ? 'ah-mega-menu-column__cards--widget'
          : 'ah-mega-menu-column__cards--push';
      },
    },
    methods: {
      handleClick () {
        this.$emit('ah-megamenu-clicked');
      },
      megaMenuColmunTitle(listItem) {
        if (listItem && listItem[0] && listItem[0].type && listItem[0].type === 'title') {
          return listItem[0].text;
        }
        return null;
      },
      back() {
        this.$emit('click:ahbar:back');
      },
      setTitleClass(category) {
        if (category && category.length && category.find((cat) => cat.type === 'title')) {
          return 'medium';
        }
        return 'large';
      },
      megaMenuClassPush() {
        return this.isWidget ? 'with-widgets' : 'with-pushs';
      },
      pushsClass() {
        return !this.isWidget ? 'ah-mega-menu__pushs' : 'ah-mega-menu__widgets';
      },
      widgetPushClicked(data) {
        this.$emit('pushClicked', { parent: this.tracking, ...data });
      },
      itemClicked(listItem) {
        this.$emit('megaMenu:itemClicked', { parent: this.tracking, ...listItem });
      },
    },
  };
</script>
